<div class="encabezado">
  <div class="container-fluid">
    <div>
      <div>
        <div>
          <h5 class="titulo1">
            {{ "titles-menu-pages.deliverys" | translate }}
          </h5>
          <!--  <p class="card-title-desc mb-0">
          {{ "pages.deliverys.description" | translate }}
        </p> -->
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <app-filter
          [ladata]="ladata"
          (filterChanged)="filterChanged($event)"
        ></app-filter>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="d-flex justify-content-end align-items-center">
              <!-- Navegación de semanas -->
              <div class="d-flex align-items-center gap-3 justify-content-end">
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm"
                  (click)="goToToday()"
                  matTooltip="{{
                    'pages.deliverys.calendar.today' | translate
                  }}"
                >
                  {{ "pages.deliverys.calendar.today" | translate }}
                </button>

                <div class="d-flex align-items-center">
                  <button
                    type="button"
                    class="btn btn-sm me-2"
                    (click)="previousWeek()"
                    matTooltip="{{
                      'pages.deliverys.calendar.previous-week' | translate
                    }}"
                  >
                    <i class="icon-chevron-left"></i>
                  </button>

                  <span class="fw-semibold text-muted px-3">
                    {{ getWeekDateRange() }}
                  </span>

                  <button
                    type="button"
                    class="btn btn-sm ms-2"
                    (click)="nextWeek()"
                    matTooltip="{{
                      'pages.deliverys.calendar.next-week' | translate
                    }}"
                  >
                    <i class="icon-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body p-0">
            <!-- Loading indicator -->
            <!--  <div *ngIf="isLoading" class="text-center p-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Cargando...</span>
              </div>
              <p class="mt-2 text-muted">
                {{ "pages.deliverys.loading" | translate }}
              </p>
            </div> -->

            <!-- Calendario semanal -->
            <div class="delivery-calendar" *ngIf="!isLoading">
              <div class="calendar-grid">
                <!-- Encabezados de días -->
                <div class="calendar-header">
                  <div
                    *ngFor="let day of weekDays"
                    class="day-header"
                    [class.today-header]="day.isToday"
                  >
                    <div class="day-name">{{ day.dayName }}</div>
                    <div class="day-number">{{ day.dayNumber }}</div>
                  </div>
                </div>

                <!-- Contenido de días -->
                <div class="calendar-content">
                  <div
                    *ngFor="let day of weekDays"
                    class="day-column"
                    [class.today-column]="day.isToday"
                  >
                    <!-- Órdenes del día -->
                    <div class="day-orders">
                      <div
                        *ngFor="let order of day.orders"
                        [ngClass]="getOrderCardClass(order.calendar_priority)"
                        matTooltip="{{
                          'pages.deliverys.calendar.view-details' | translate
                        }}"
                        class="clickable"
                      >
                        <div
                          class="order-color d-flex justify-content-end"
                          (click)="reProgramar(order.reference)"
                        >
                          <span class="order-status text-dark"
                            ><u>
                              <i class="icon-arrows-split"></i
                              >   {{ "inputs.reprogramar" | translate }}</u
                            >
                          </span>
                        </div>
                        <div
                          (click)="openOrderInNewTab(order.reference)"
                          class="mt-3"
                        >
                          <div
                            class="order-supplier"
                            *ngIf="order.vendor_reference"
                          >
                            <i class="icon-store me-1"></i>
                            {{ order.vendor_reference }}
                          </div>
                          <div
                            class="order-supplier"
                            *ngIf="order.supplier_reference"
                          >
                            <i class="icon-store text-muted me-1"></i>
                            {{ order.supplier_reference }}
                          </div>

                          <div class="order-vehicle" *ngIf="order.vehicle">
                            <span
                              ><i class="icon-car text-muted me-1"></i>
                              {{ order.vehicle }}</span
                            >
                          </div>

                          <div class="order-color" *ngIf="order.colour">
                            <i class="icon-drop2 text-muted me-1"></i>
                            {{ order.colour }}
                          </div>
                          <div class="order-client" *ngIf="order.client">
                            <span>
                              <i class="icon-user text-muted me-1"></i>

                              {{ order.client.fullname }}</span
                            >
                          </div>
                          <div class="order-color" *ngIf="order.license_plate">
                            <span
                              ><i class="icon-map-marker text-muted me-1"></i>
                              {{ order.license_plate }}
                            </span>
                          </div>
                          <div
                            class="order-color"
                            *ngIf="order.delivery_postal_code"
                          >
                            <span
                              ><i class="icon-map-marker text-muted me-1"></i>
                              {{ order.delivery_postal_code }} ({{
                                order.delivery_city
                              }})</span
                            >
                          </div>
                          <div class="order-color mt-3">
                            <span class="badge1 order-status">
                              {{
                                "badge-status_select-stage." + order.stage
                                  | translate
                              }}
                            </span>
                          </div>
                          <div
                            class="order-color"
                            *ngIf="order.delivery_status"
                          >
                            <span class="badge2 order-status">
                              {{
                                "badge-status_select-stage." +
                                  order.delivery_status | translate
                              }}
                            </span>
                          </div>
                        </div>
                      </div>

                      <!-- Mensaje cuando no hay órdenes -->
                      <div *ngIf="day.orders.length === 0" class="no-orders">
                        <i class="icon-calendar-empty text-muted"></i>
                        <small class="text-muted">{{
                          "pages.deliverys.calendar.no-deliveries" | translate
                        }}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
